import CategoryAssets from '@/services/CategoryAssets';
import { ScrollStateEnum } from '@/enum/scroll_state';
import { ClosetStateEnum } from '@/enum/closet_state';
import { OutfitSelectionTypeEnum } from '@/enum/outfit_selection_type';

import { FULL_BODY_CATEGORY_KEYS } from '@/constants';
import { FlowModeEnum } from '@/enum/flow_mode';
import { ExitDialogTypeEnum } from '@/enum/exit_dialog_type';
import { OutfitSharingStateEnum } from '@/enum/outfit_sharing_state';

const initialCategoryIsFullBody = (
  { gender, style }: Record<string, number>,
  flowMode: FlowModeEnum,
  categoryIndex: number,
) => {
  const category = CategoryAssets.getFlatCategoryList(gender, style, flowMode)[categoryIndex];
  return FULL_BODY_CATEGORY_KEYS.includes(category);
};

const state = (
  initialTraits: Record<string, number>,
  flowMode: FlowModeEnum,
  categoryIndex: number,
  initialSectionId: number | null,
  centerActiveCategoryIcon: boolean,
  assetOverrides: string[],
  is3dMode: boolean,
  forceShowExitDialog: boolean,
  exitDialogType: ExitDialogTypeEnum,
): RootState => {
  return {
    categories: [],
    is3dMode,
    bottomWrapDown: false,
    builderIsFocused: true,
    forceShowExitDialog: forceShowExitDialog, // (Read-only) Value optionally passed in at launch
    exitDialogType,
    selectedCategoryIndex: categoryIndex,
    newCategoryIndex: categoryIndex, // Store category index to be transitioned to
    initialTraits: Object.assign({}, initialTraits), // (Read-only) Traits passed in at launch
    selectedTraits: {},
    traitOrigins: {},
    isIOS12: false,
    selectedColourOptionsForTraitItems: {},
    scrollerFunction: undefined, // TODO - move to isolated module
    flowMode,
    categoryMetadata: {},
    facialFeatureTraits: {},
    scrollState: ScrollStateEnum.IDLE, // Do not change the initial value from "IDLE"
    isFullBodyCategory: initialCategoryIsFullBody(initialTraits, flowMode, categoryIndex),
    selectedColourPalettesForMixAndMatchItems: {},
    isSavingAvatar: false,
    disableUndoRedoButton: false,
    setShouldShowUnsupportedOSError: false,
    // Closet states
    closetItems: null,
    closetItemsSixthBody: null,
    closetState: ClosetStateEnum.NOT_LOADING,
    // Outfit states
    outfitSelectionType: OutfitSelectionTypeEnum.FULL, // Outfit selection type indicates whether the current outfit pieces were seleted invidiually or as a whole outfit.
    hasTappedMixAndMatchItemInSession: false,
    mixAndMatchColourGroups: {},
    mixAndMatchMetadata: {},
    facialFeaturesMetadata: {},
    topToggleTuckState: 0,
    isTopToggleDisabled: false,
    avatarActions: [],
    avatarActionIndex: -1,
    previousUndoRedoAction: null,
    sixthBodyLegacyOutfits: null,
    initialSectionId,
    centerActiveCategoryIcon,
    outfitSharingState: OutfitSharingStateEnum.NOT_LOADING,
    // Dialogs
    shouldShowDeleteSelfieDialog: false,
    shouldShowExitDialog: false,
    shouldShowOutfitDialog: false,
    shouldShowUnsupportedOSError: false,
    shouldShowItemUnavailableDialog: false,
    backgroundId: null,
    backgroundType: null,
    backgroundUrl: null,
    selectedBackgroundIds: new Set(),
    isSelfiePreviewDismissed: false,
    isSelfiePreviewExpanded: false,
    assetOverrides: assetOverrides,
    /** @type BuilderPromotions */
    initialPromotions: {
      categories: new Set(),
      sections: [],
      options: [],
    },
    /** @type BuilderPromotions */
    stalePromotions: {
      categories: new Set(),
      sections: [],
      options: [],
    },
    tuckStateForTop: {},
  };
};

export default state;
